import { render } from "./DialogPractice.vue?vue&type=template&id=db3d82fa&scoped=true"
import script from "./DialogPractice.vue?vue&type=script&lang=js"
export * from "./DialogPractice.vue?vue&type=script&lang=js"

import "./DialogPractice.vue?vue&type=style&index=0&id=db3d82fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db3d82fa"]])

export default __exports__